import useSWR from "swr";

import { simpleFetcher } from "../fetcher";
import { type TierDetails } from "~/api/types";

interface TierWithDocuments extends TierDetails {
  details: {
    documents: number;
  };
}

export function useTierDetails(id?: number, revalidateOnMount = false) {
  const { data, error, mutate } = useSWR<TierWithDocuments, Error>(
    id ? `/api/v2/tiers/${id}/details` : null,
    simpleFetcher,
    {
      revalidateOnFocus: false,
      revalidateOnMount,
    },
  );
  return { data, error, mutate, isLoading: !data && !error };
}
